import React, { Component } from 'react'
import PropTypes from 'prop-types'
import actions from 'redux/actions'
import { links, constants } from 'common/helpers'

import ModalWithActions from 'components/modal/ModalWithActions/ModalWithActions'
import Text from 'components/_new/typography/Text/Text'

import messages from './messages'


class UnpauseSuccessModal extends Component {

  static propTypes = {
    name: PropTypes.string,
    data: PropTypes.shape({
      unpauseCode: PropTypes.oneOf(Object.values(constants.unpauseTypes)),
      unpauseFreeCase: PropTypes.bool,
    }),
  }

  static defaultProps = {
    name: constants.modals.pauseSubscription.UnpauseSuccess,
  }

  constructor() {
    super()

    this.actions = [
      {
        brand: true,
        title: messages.buttonQuiz,
        onClick: this.navToQuiz,
      },
      {
        whiteGray: true,
        title: messages.buttonSkip,
        onClick: this.close,
      },
    ]
  }

  close = () => {
    const { name } = this.props

    actions.models.modals.close(name)
  }

  navToQuiz = () => {
    this.close()

    actions.models.router.push(links.quiz)
  }

  render() {
    const { name, data: { unpauseCode, unpauseFreeCase } } = this.props

    let text = messages.textDefault

    if (unpauseCode === constants.unpauseTypes.unpause5) {
      text = messages.text5off
    }
    else if (unpauseCode === constants.unpauseTypes.unpause50) {
      text = messages.text50off
    }
    else if (unpauseCode === constants.unpauseTypes.unpausefree) {
      text = messages.textFree
    }
    else if (unpauseFreeCase) {
      text = messages.textCase
    }

    return (
      <ModalWithActions
        name={name}
        title={messages.title}
        actions={this.actions}
      >
        <Text message={messages.textStart} tag="span" size="16-24" />{' '}
        <Text message={text} tag="span" size="16-24" html />
      </ModalWithActions>
    )
  }
}


export default UnpauseSuccessModal
